@if (state === 'loading') {
  <app-spinner></app-spinner>
}
@if (state === 'empty') {
  <tyt-not-found
    title="Nothing to play"
    message="Looks like there is nothing to watch or listen to on this episode."
    [checkRedirect]="false"
    [checkForUpdates]="false"
  ></tyt-not-found>
  @if (user?.staff) {
    <div style="text-align: center;">
      <a mat-raised-button routerLink="/watch/edit/{{production.id}}">
        <mat-icon>edit</mat-icon>
        Edit Production
      </a><br/>
      <em>This is only shown to staff</em>
    </div>
  }
}
@if (state === 'not-found') {
  <tyt-not-found
    [checkRedirect]="false" [checkForUpdates]="false"
    [title]="notFoundTitle"
    [message]="notFoundMessage"
  ></tyt-not-found>
  @if (user?.staff && production) {
    <div style="text-align: center;">
      <a mat-raised-button routerLink="/watch/edit/{{production.id}}">
        <mat-icon>edit</mat-icon>
        Edit Production
      </a><br/>
    </div>
  }
  <tyt-staging-note [shown]="true">
    If you arrived here by a link within the site, please report this to engineering.
    No link within TYT.com should lead to this condition.
  </tyt-staging-note>
}
@if (state === 'ready') {
  <tyt-media-view
    [production]="production"
    [show]="show"
    [item]="currentItem"
    (itemChange)="setCurrentItem($event)"
    [mode]="mode"
    (modeChange)="setCurrentMode($event)"
  [user]="user"></tyt-media-view>
}
